import script from "./HeaderLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderLabel.vue?vue&type=script&setup=true&lang=js"

import "./HeaderLabel.vue?vue&type=style&index=0&id=61abe442&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61abe442"]])

export default __exports__